/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Import Form
import { Form, Col, Row, FormControl, Button } from "react-bootstrap";

/* eslint-enable */

//Import Loading
// import LoadingAlert from "../../components/LoadingAlert";

// Import Modal
import Modal from "react-bootstrap/Modal";

function MemberForm(props) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(false);

  const handleClose = () => {
    props.hidden_func(false);
    setErrors({});
    setForm({});
  };

  const setField = (field, value) => {
    if (errors[field.name])
      setErrors({
        ...errors,
        [field.name]: null,
      });

    setForm({
      ...form,
      [field.name]: value,
    });
  };
  const findFormErrors = () => {
    const { memberNumber } = form;
    const newErrors = {};

    // start date errors
    if (!memberNumber || memberNumber == "")
      newErrors.memberNumber = "กรุณากรอกเลขสมาชิก";

    return newErrors;
  };

  useEffect(() => {
    // console.log(props);
    const birthdate = new Date(props.farmerdata.birth_date);
    setForm({
      ...form,
      ["birth_date"]: birthdate.toLocaleString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
    });
  }, [props]);
  // console.log(props);

  // const getFarmer = (farmer_idcard) => {
  //   FarmerService.getFarmerById(farmer_idcard).then((data) => {
  //     setFarmer(data.data.farmer);
  //   });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const newform = {
        assoc_id: props.assocdata.association_id,
        farmer_id: props.farmerdata.farmer_id,
        member_code: form.memberNumber,
        person_card: props.farmerdata.id_card,
      };
      props.onsubmit(newform);
      console.log(newform);
    }
  };

  return (
    <>
      <Modal size="md" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มข้อมูลสมาชิก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          สมาคม : {" " + props.assocdata.assocname}
          <br />
          ชื่อ - นามสกุล :{" "}
          {props.farmerdata.pre_name +
            " " +
            props.farmerdata.first_name +
            " " +
            props.farmerdata.last_name}
          <br />
          หมายเลขบัตร :{" " + props.farmerdata.id_card}
          <br />
          ที่อยู่ :{" "}
          {props.farmerdata.address +
            " " +
            props.farmerdata.tam_namt +
            " " +
            props.farmerdata.amp_namt +
            " " +
            props.farmerdata.prov_namt}
          <br />
          เพศ : {props.farmerdata.sex}
          <br />
          วันเกิด : {form.birth_date}
          <br />
          เบอร์โทร : {props.farmerdata.tel}
          <hr />
          <Form>
            <Form.Group as={Row} className="mb-12">
              <FormControl
                type="number"
                name="assoc_id"
                value={props.assocdata.association_id}
                hidden={true}
              />
              <Form.Control.Feedback type="invalid">
                {errors.memberNumber}
              </Form.Control.Feedback>
              <Col sm="3">
                {/* <Form.Label column sm="3"> */}
                เลขสมาชิก :{/* </Form.Label> */}
              </Col>
              <Col sm="9">
                <FormControl
                  placeholder="กรอกเลขสมาชิก"
                  type="number"
                  name="memberNumber"
                  value={form.memberNumber}
                  onChange={(e) => setField(e.target, e.target.value)}
                  isInvalid={!!errors.memberNumber}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.memberNumber}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
          </Form>
          {/* {JSON.stringify(props)} */}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            Close
          </button>
          <button
            className="btn btn-primary"
            // type="submit"
            onClick={handleSubmit}
          >
            Save Changes
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MemberForm;

MemberForm.propTypes = {
  show: PropTypes.bool,
  hidden_func: PropTypes.func,
  onsubmit: PropTypes.func,
  farmerdata: PropTypes.object,
  assocdata: PropTypes.object,
};

MemberForm.defaultProps = {
  assocdata: {
    association_id: "",
    association_name_th: "",
  },
  farmerdata: {
    pre_name: "",
    first_name: "",
    last_name: "",
    address: "",
    tam_namt: "",
    amp_namt: "",
    prov_namt: "",
    sex: "",
    birth_date: "",
    tel: "",
  },
};
